import { CenyVelikostiModal } from '@/components/druhaJakost/CenyVelikostiModal';
import { apiFetch } from '@/lib/apiFetch';
import { type Zalozena, errMsg, parseSleva, zalozitShoptet } from '@/lib/druhaJakost';
import { useState } from 'react';

/** Buňka „Shoptet CZ" v seznamu — stav, případně dodatečné založení. */
export function ShoptetCell({
  item,
  onDone,
}: { item: Zalozena; onDone: (msg: string, ok: boolean) => void }) {
  const [sleva, setSleva] = useState('');
  const [busy, setBusy] = useState(false);
  const [ceny, setCeny] = useState(false);

  // Příznak + nákupní ceny pro 2. jakosti založené dřív, než to zakládání umělo.
  const dorovnat = async () => {
    const p = parseSleva(sleva) ?? item.shoptet_cz_sleva;
    if (!p) return;
    setBusy(true);
    try {
      const res = await apiFetch<{ warning: string | null }>(
        `/api/druha-jakost/${item.id}/shoptet-cz/dorovnat`,
        { method: 'POST', body: { sleva_pct: p } },
      );
      onDone(
        res.warning
          ? `Doplněno, ale: ${res.warning}`
          : `${item.new_code}: příznak a ceny dorovnány`,
        !res.warning,
      );
    } catch (e: unknown) {
      onDone(errMsg(e, 'Doplnění selhalo.'), false);
    } finally {
      setBusy(false);
    }
  };

  if (item.shoptet_cz_guid) {
    return (
      <span className="text-action-dark">
        ✓ založeno
        {item.shoptet_cz_sleva
          ? ` · sleva ${String(item.shoptet_cz_sleva).replace('.', ',')} %`
          : ''}
        {item.shoptet_cz_error && (
          <span className="block text-xs text-warning">{item.shoptet_cz_error}</span>
        )}
        <span className="flex items-center gap-2 mt-1">
          <input
            type="text"
            inputMode="decimal"
            value={sleva}
            onChange={(e) => setSleva(e.target.value)}
            placeholder={item.shoptet_cz_sleva ? `${item.shoptet_cz_sleva} %` : 'Sleva %'}
            className="w-20 rounded border border-border bg-surface px-2 py-0.5 text-xs text-text text-right focus:outline-none focus:border-primary"
          />
          <button
            type="button"
            onClick={() => void dorovnat()}
            disabled={busy || !(parseSleva(sleva) ?? item.shoptet_cz_sleva)}
            className="text-xs text-text-secondary underline hover:text-text disabled:opacity-50 cursor-pointer whitespace-nowrap"
          >
            {busy ? 'Dorovnávám…' : 'Dorovnat ceny a příznak'}
          </button>
        </span>
        <button
          type="button"
          onClick={() => setCeny(true)}
          className="block mt-1 text-xs text-text-secondary underline hover:text-text cursor-pointer"
        >
          Ceny po velikostech
          {Object.keys(item.shoptet_cz_sleva_vel ?? {}).length > 0 &&
            ` (${Object.keys(item.shoptet_cz_sleva_vel).length} výjimek)`}
        </button>
        {ceny && <CenyVelikostiModal item={item} onClose={() => setCeny(false)} onDone={onDone} />}
      </span>
    );
  }

  const go = async () => {
    const p = parseSleva(sleva);
    if (!p) return;
    setBusy(true);
    try {
      const warning = await zalozitShoptet(item.id, p);
      onDone(warning ? `Založeno, ale: ${warning}` : `${item.new_code} založeno v Shoptetu`, true);
    } catch (e: unknown) {
      onDone(errMsg(e, 'Založení v Shoptetu selhalo.'), false);
    } finally {
      setBusy(false);
    }
  };

  return (
    <div className="min-w-56">
      {item.shoptet_cz_error && (
        <div className="text-xs text-danger mb-1">{item.shoptet_cz_error}</div>
      )}
      <div className="flex items-center gap-2">
        <input
          type="text"
          inputMode="decimal"
          value={sleva}
          onChange={(e) => setSleva(e.target.value)}
          placeholder="Sleva %"
          className="w-24 rounded border border-border bg-surface px-2 py-1 text-sm text-text text-right focus:outline-none focus:border-primary"
        />
        <button
          type="button"
          onClick={() => void go()}
          disabled={busy || !parseSleva(sleva)}
          className="rounded bg-action px-3 py-1 text-xs font-semibold text-white hover:bg-action-dark disabled:opacity-50 cursor-pointer whitespace-nowrap"
        >
          {busy ? 'Zakládám…' : item.shoptet_cz_error ? 'Zkusit znovu' : 'Založit v Shoptetu'}
        </button>
      </div>
    </div>
  );
}
